var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A24456FE-20A9-4E02-8120-259C697E0A29") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-update-stock",
    transform: "translate(-748, -772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "down",
    transform: "translate(748, 772)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#CEFAB7"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.1, 16) scale(1, -1) rotate(-90) translate(-16.1, -16)translate(7.2333, 8.5667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.36666667,14.5000133 C9.12222667,14.2556133 9,13.9444133 9,13.56668 C9,13.1889467 9.12222667,12.8777467 9.36666667,12.6333467 L14.5666667,7.43334667 L9.36666667,2.23333333 C9.12222667,1.98888 9,1.67777333 9,1.3 C9,0.922213333 9.12222667,0.611106667 9.36666667,0.366666667 C9.61110667,0.122213333 9.92222667,-3.19224558e-15 10.3,-3.19224558e-15 C10.6777733,-3.19224558e-15 10.9888933,0.122213333 11.2333333,0.366666667 L17.3666667,6.50001333 C17.5,6.63334667 17.5944,6.77774667 17.65,6.93334667 C17.7056,7.08894667 17.7333333,7.25561333 17.7333333,7.43334667 C17.7333333,7.61108 17.7056,7.77774667 17.65,7.93334667 C17.5944,8.08894667 17.5,8.23334667 17.3666667,8.36668 L11.2333333,14.5000133 C10.9888933,14.7444133 10.6777733,14.86668 10.3,14.86668 C9.92222667,14.86668 9.61110667,14.7444133 9.36666667,14.5000133 Z",
    id: "Path-Copy",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "evenodd",
    x: 0,
    y: 6,
    width: 16,
    height: 3,
    rx: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.54750c8ad2cae9ff4e2a1b4ca229ed1d.svg";
export { ForwardRef as ReactComponent };